'use client'

import { Button, EmptyState, Image } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useAsset } from '@marketplace-web/shared/assets'

type Props = {
  onRetryClick?: () => void
}

// TODO: switch to translations with error_page prefix when translated
const LoadingFailedEmptyState = ({ onRetryClick }: Props) => {
  const translate = useTranslate('conversations.loading_failed_empty_state')
  const asset = useAsset('/assets/error-page')

  function renderRetryAction() {
    return <Button onClick={onRetryClick} styling="filled" text={translate('actions.retry')} />
  }

  return (
    <EmptyState
      title={translate('title')}
      body={translate('body')}
      action={!!onRetryClick && renderRetryAction()}
      image={<Image src={asset('failed-to-load.svg')} />}
    />
  )
}

export default LoadingFailedEmptyState
